import { render } from "./StockPartForm.vue?vue&type=template&id=48118fba"
import script from "./StockPartForm.vue?vue&type=script&lang=js"
export * from "./StockPartForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__